import { render, staticRenderFns } from "./Antenna.vue?vue&type=template&id=0e48a627&scoped=true"
import script from "./Antenna.vue?vue&type=script&lang=ts"
export * from "./Antenna.vue?vue&type=script&lang=ts"
import style0 from "./Antenna.vue?vue&type=style&index=0&id=0e48a627&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48a627",
  null
  
)

export default component.exports